import React from "react";
import { CONSTANTS, SOCIAL_SOURCES } from "../../../constants/app-constant";
import { Table } from "react-bootstrap";
import { FacebookIcon, InstagramIcon, TwitterIcon, TwitterWBIcon, YoutubePlayIcon } from "../../Icons/icons.component";
import { containsNumber, convertToInternationalCurrencySystem } from "../../../utility/common-methods";
const { DATA_NOT_FOUND } = CONSTANTS;
const { FACEBOOK, INSTAGRAM, TWITTER, YOUTUBE, PINTEREST,LINKEDIN } = SOCIAL_SOURCES;

const TopPostersChart = ({
  chartTitle,
  data,
  entityList,
  reportType,
  onEntityClick,
  identifier,
  dataByReportType,
  type,
  channelType,
  setFromUserName
}) => {
  const handleUsernameClick = (e, data, mode = 0) => {
    e.preventDefault();
    e.stopPropagation();
    setFromUserName(data)
    mode === 1 && data && window.open(`https://twitter.com/${data}`, "_blank");
    mode === 2 && containsNumber(data) && data && window.open(`https://linkedin.com/in/${data}`, "_blank");
    mode === 2 && !containsNumber(data) && data && window.open(`https://linkedin.com/company/${data}`, "_blank");
    
  };
  const handleCountClick = (e, legend, label, from_username, channelType) => {
    try {
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;

      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      routeParams.from_username = from_username;
      routeParams.channel_type = [channelType];
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className="customTableWrap">
      <div className="widgetHeading">Top Posters</div>
      <div className="table-responsive">
        <Table className="table table-sm table-bordered customTable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Entity</th>
              <th>Platform</th>
              <th>No. Of Posts</th>
              {channelType.includes(TWITTER)?
                <>
                  <th>Author Like</th>
                  {/* <th>Author Listed</th> */}
                  <th>Author Tweet</th>
                  <th>Author Follower</th>
                </>
                :""
              }
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) &&
              data.map((el) => {
                const {
                  from_username,
                  count,
                  topic_id,
                  topic_category,
                  topic_name,
                  channel_type,
                  likes_count,
                  tweets_count,
                  listed_count,
                  follower_count
                } = el || {};
                return (
                  <React.Fragment key={topic_id}>
                    <tr>
                      <td>
                        {channel_type == TWITTER ? (
                          <strong>
                            <a
                              className="influencersLink"
                              onClick={(e) =>
                                handleUsernameClick(e, from_username,1)
                              }
                            >
                              {`@${from_username}`}
                            </a>
                          </strong>
                        ) : (channel_type == LINKEDIN ?
                          <strong>
                            <a
                              className="influencersLink"
                              onClick={(e) =>
                                handleUsernameClick(e, from_username,2)
                              }
                            >
                              {`@${from_username}`}
                            </a>
                          </strong>
                          :(
                          from_username?<strong onClick={() => {setFromUserName(from_username)}}>{from_username}</strong>:"Other"
                        ))}
                      </td>
                      <td>{topic_name}</td>
                      {channel_type == FACEBOOK && <td><FacebookIcon /></td>}
                      {channel_type == INSTAGRAM && <td><InstagramIcon /></td>}
                      {channel_type == TWITTER && <td><TwitterWBIcon /></td>}
                      {channel_type == YOUTUBE && <td><YoutubePlayIcon /></td>}
                      {channel_type == LINKEDIN && <td><img
                        src="https://backendportal.conceptbiu.com/assets/article_download/icons8-linkedin-30.png"
                        alt="NA"
                        width={25}
                        height={25}
                      /></td>}
                      {/* {channel_type == PINTEREST && <td>Pinterest</td>} */}
                      <td>
                        {" "}
                        <strong>
                          <a
                            className="influencersLink"
                            onClick={(e) =>
                              handleCountClick(
                                e,
                                null,
                                topic_name,
                                from_username,
                                channel_type
                              )
                            }
                          >
                            {`${count}`}
                          </a>
                        </strong>
                      </td>
                      {channelType.includes(TWITTER)?
                        <>
                          <th>{channel_type == TWITTER?convertToInternationalCurrencySystem(likes_count):"-"}</th>
                          {/* <th>{channel_type == TWITTER?convertToInternationalCurrencySystem(listed_count):"-"}</th> */}
                          <th>{channel_type == TWITTER?convertToInternationalCurrencySystem(tweets_count):"-"}</th>
                          <th>{channel_type == TWITTER?convertToInternationalCurrencySystem(follower_count):"-"}</th>
                        </>
                        :""
                      }
                    </tr>
                  </React.Fragment>
                );
              })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TopPostersChart;
